import GS from '../../grafsync/grafsync';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { CardHeader, Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles } from '../style/gstheme';
import reportsList from './prebuilt-reports';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { PROJECT_COLOURS } from '../utils/constants';

const styles = (theme) => {
  return Object.assign({
    actions: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    reports: {
      backgroundColor: '#f8f8f8',
      overflow: 'auto',
      borderRadius: 4,
      padding: 16
    },
    reportCard: {
      maxWidth: '282px',
      margin: 'auto',
      boxShadow: '0px 1px 3px #00000033',
      '&:hover': {
        boxShadow: '0px 12px 17px #00000024'
      }
    },
    reportCardContent: {
      height: '60px'
    },
    reportCardHeadingContent: {
      maxHeight: '90px',
      overflow: 'hidden',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    reportCardHeading: {
      color: 'white',
      fontFamily: 'rajdhani',
      fontSize: '24px',
      fontWeight: 500,
      textAlign: 'center',
      backgroundColor: theme.palette.primary.main,
      height: '98px'
    }
  }, globalStyles);
};

class ReportsDisplay extends Component {

  render() {

    const { classes, runQuery, projectType, skosXL } = this.props;
    const reports = reportsList().filter(report => (!report.projectType || report.projectType === projectType)
      && (!report.skosXL || skosXL)
      && (!report.subscriptionType || report.subscriptionType.includes(GS.getActiveSubscriptionType())));
    const reportCategories = [...new Set(reports.map(r => r.category))];

    return (
      <div data-test="predefined-reports" className={classes.reports}>
        <div style={{ float: 'left', width: 'calc(100% - 350px)' }}>
          {reportCategories.map((rc, rcIndex) => <div
            key={rc}
            style={{ marginBottom: 24 }}>
            <Typography className={classes.subMainHeading}>{rc}</Typography>
            <Grid container spacing={4}>
              {reports
                .filter(r => r.category === rc)
                .map((report, index) =>
                  <Grid key={index} item>
                    <Card data-test={"Report-" + report.id} className={classes.reportCard} name="reportCard">
                      <CardHeader
                        data-test="report-card-title"
                        disableTypography
                        classes={{
                          content: classes.reportCardHeadingContent
                        }}
                        onClick={() => runQuery(report, true)}
                        className={classes.reportCardHeading}
                        style={{ backgroundColor: '#' + PROJECT_COLOURS[(rcIndex + index) % PROJECT_COLOURS.length] }}
                        title={report.title["en"]} />
                      <CardContent className={classes.reportCardContent}>
                        <Typography data-test="project-description" variant="body2">{report.description["en"]}</Typography>
                      </CardContent>
                      <CardActions className={classes.actions}>
                        <IconButton
                          data-test="run-report"
                          aria-label={"Run report for " + report.title["en"]}
                          size="small"
                          onClick={() => runQuery(report, true)}
                          style={{ width: 40, height: 40, verticalAlign: 'middle', paddingTop: 8 }}>
                          <ArrowForwardIcon className={classes.actionButton} />
                        </IconButton>
                      </CardActions>
                    </Card>
                  </Grid>
                )}
            </Grid>
          </div>
          )}
        </div>
        <div style={{ float: 'right', width: '300px', borderRadius: 4, backgroundColor: '#eeeeee', padding: 12, minHeight: 300 }}>
          <Typography className={classes.subMainHeading}><AssessmentIcon size="large" style={{ verticalAlign: 'middle' }} /> Creating and Running Reports</Typography>
          <Typography variant="body2" paragraph>Reports allow you to generate information about your data that you can customise to implement your business rules.</Typography>
          <Typography variant="body2" paragraph>To set up reports use the SPARQL console. Once set up they will appear in the drop-down list above.</Typography>
          <Typography variant="body2" paragraph>Alternatively, you can run one of the predefined reports that are commonly needed.</Typography>
        </div>
      </div>
    );
  }
}

ReportsDisplay.defaultProps = {
  skosXL: false
};

ReportsDisplay.propTypes = {
  runQuery: PropTypes.func.isRequired,
  skosXL: PropTypes.bool,
  projectType: PropTypes.string.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(ReportsDisplay);